import React from 'react'
import TopLevel from '../Components/Categories/TopLevelCategories'
import { handleClick } from './Functions'

const SideMenu = ({ setState, state, varNames }) => {
  if (state.isAdmin) {
    console.log('Side Menu State:', state)
  }
  return (
    <aside className='sidemenu-wrapper'>
      <div className='menu-main-menu-container'>
        <ul id='menu-main-menu-1' className='menu'>
          <li className='menu-item'>
            <a
              onClick={() => handleClick({
                location: '',
                setState: (state) => setState(state),
                state,
                varNames
              })}
              aria-current='page'
            >
              All Photos
            </a>
          </li>
          {(() => TopLevel.map((value, index) => (
            <li className='menu-item' key={index}>
              <a
                onClick={() => handleClick({
                  location: value.split(' ').join('-').toLowerCase(),
                  setState: (state) => setState(state),
                  state,
                  varNames
                })}
              >
                {value}
              </a>
            </li>
          )))()}
        </ul>
      </div>
    </aside>
  )
}

export default SideMenu
